import React from 'react';

import { Box, CheckboxCard, Grid, Select, TextInput } from 'ui';

import { tokenExUtils } from '../utils';
import { useUserTokenExFormContext } from './FormContext';

type Props = {
  withCvv?: boolean;
  withSaveCardCheckbox?: boolean;
};

const ZipField = () => {
  const form = useUserTokenExFormContext();

  // Really just handle the replacement.
  // As long as we utilize the from: We can update via form.setFieldValue
  const onZipChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { target } = e;
    form.setFieldValue('zip', target.value.replace(/[^0-9]/g, ''));
  };

  return (
    <TextInput
      id={tokenExUtils.ZipID}
      placeholder="Zip"
      name="zip_code"
      autoComplete="shipping postal-code"
      onKeyDown={(e) => {
        // This is kind of redundant but is an "Almost" - alternative for
        // the onchange above.
        const letterRegex = new RegExp('^[a-zA-Z]{1}$');
        const letter = letterRegex.test(e.key);
        if (letter || e.code == 'Space') {
          e.preventDefault();
        }
      }}
      {...form.getInputProps('zip')}
      onChange={onZipChange}
    />
  );
};

const Fields = ({ withCvv = true, withSaveCardCheckbox = false }: Props) => {
  const form = useUserTokenExFormContext();

  return (
    <Grid grow gutter={8}>
      <Grid.Col span={withCvv ? 8 : 12}>
        <Box style={{ position: 'relative', height: 45, width: '100%' }}>
          <Box id={tokenExUtils.NumberID} style={{ position: 'absolute' }} />
        </Box>
      </Grid.Col>

      {withCvv && (
        <Grid.Col span={withCvv ? 4 : 0}>
          <Box style={{ position: 'relative', height: 45, width: '100%' }}>
            <Box id={tokenExUtils.CvvID} style={{ position: 'absolute' }} />
          </Box>
        </Grid.Col>
      )}

      <Grid.Col span={4}>
        <Select.Months {...form.getInputProps('month')} />
      </Grid.Col>

      <Grid.Col span={4}>
        <Select.Years {...form.getInputProps('year')} />
      </Grid.Col>

      <Grid.Col span={4}>
        <ZipField />
      </Grid.Col>
      <Grid.Col span={12}>
        <TextInput
          id={tokenExUtils.NameID}
          placeholder="Name On Card"
          autoComplete="cc-name"
          name="full_name"
          {...form.getInputProps('name')}
        />
      </Grid.Col>

      {withSaveCardCheckbox && (
        <Grid.Col span={12}>
          <CheckboxCard
            description="Save this card for future payments"
            {...form.getInputProps('shouldSaveCard')}
          />
        </Grid.Col>
      )}
    </Grid>
  );
};
export { Fields };
